(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-parts/assets/javascripts/footers/coupon-footer-fulltraff-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-parts/assets/javascripts/footers/coupon-footer-fulltraff-rows.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSystemSize = _svs$components$tipse.selectSystemSize,
  selectNumberOfCompletedBoards = _svs$components$tipse.selectNumberOfCompletedBoards;
const CouponFooterRowsView = svs.components.tipsen.couponOverviewParts.CouponFooterRowsView;
const CouponFooterFulltraffRows = _ref => {
  let price = _ref.price,
    system = _ref.system;
  const couponId = useCouponId();
  const completedBoards = useSelector(state => selectNumberOfCompletedBoards(state, couponId));
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const goalCountNumRows = completedBoards > 0 ? selectedSystemSize : 0;
  const _price = price ? price : 0;
  return React.createElement(CouponFooterRowsView, {
    hasRowLabel: true,
    numRows: goalCountNumRows,
    price: _price,
    system: system
  });
};
setGlobal('svs.components.tipsen.couponOverviewParts.CouponFooterFulltraffRows', CouponFooterFulltraffRows);

 })(window);